module.exports = __webpack_public_path__ + "static/media/pos-facil-logo.0acb4484.png";